export default __webpack_public_path__ + "a46510791777a15d9b1771be91689eff.png";